import { render, staticRenderFns } from "./ISFDetailTimeline.vue?vue&type=template&id=983e8e4c&"
import script from "./ISFDetailTimeline.vue?vue&type=script&lang=js&"
export * from "./ISFDetailTimeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports